import { render, staticRenderFns } from "./MdmSoftwareDistribute.vue?vue&type=template&id=3b8a03a3&scoped=true&"
import script from "./MdmSoftwareDistribute.vue?vue&type=script&lang=js&"
export * from "./MdmSoftwareDistribute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8a03a3",
  null
  
)

export default component.exports